<p-dialog
  modal="true" [(visible)]="displayDropActivityDialog"
  [closable]="false"
  [minY]="350"
  styleClass="atlas-dialog-s"
  [focusOnShow]="false"
  [contentStyle]="{ 'max-height': '75vh' }"
>
  <ng-template pTemplate="header">
    <h4 style="font-weight: normal">
      <span>{{ 'profiles.edit.drop-activity.create-drop-activity' | translate | ucfirst }} </span>
    </h4>
  </ng-template>
  <div class="drop-modal-body">
    <div>
      <p-select
        name="selectedDropType"
        [options]="dropMemberActivities"
        [placeholder]="'common.select' | translate | titlecase"
        optionLabel="ActivityType"
        dataKey="ActivityTypeID"
        [(ngModel)]="selectedDropActivity"
        [style]="{ width: '100%' }"
        appendTo="body"
      ></p-select>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <button pButton type="button" class="atlas-btn atlas-btn-default" (click)="closeDialog()">{{ 'common.cancel' | translate | uppercase }}</button>
    <button pButton type="button" class="btn btn-primary" [disabled]="selectedDropActivity == null" (click)="createActivity()">
      {{ 'profiles.edit.drop-activity.create-drop-activity' | translate | uppercase }}
    </button>
  </ng-template>
</p-dialog>
